import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import useToggleState from 'src/hooks/useToggleState'
import AddModal from './AddModal'

interface DistributionsProps {
  id: number
}

const Distributions: React.FC<DistributionsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Distributions'
        primaryAction={{
          key: 'add-distribution',
          icon: faPlus,
          text: 'Add Distribution(s)',
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<Table options={{ data: [], columns }} suspend={3} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <AddModal positionId={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Distributions
